import { Adapter as d, getAdapter as t } from "../../../adapter.js";
import { AdyenPaymentMethodsResponse as m } from "./adyenPaymentMethodsResponse.model.js";
import { AdyenStoredPaymentMethodAdapter as r } from "./adyenStoredPaymentMethod/adyenStoredPaymentMethod.adapter.js";
import { AdyenPaymentMethodAdapter as p } from "./adyenPaymentMethod/adyenPaymentMethod.adapter.js";
class i extends d {
  adapt(e) {
    const o = t(p), n = t(r);
    return new m({
      paymentMethods: (e.payment_methods ?? []).map(o.adapt),
      storedPaymentMethods: (e.stored_payment_methods ?? []).map(n.adapt),
      clientKey: e.client_key,
      environment: e.environment
    });
  }
  serialize(e) {
  }
}
export {
  i as AdyenPaymentMethodsResponseAdapter
};
//# sourceMappingURL=adyenPaymentMethodsResponse.adapter.js.map
